import type {
  DatasetType,
  EDITOR_TYPE,
  Features,
} from '@wix/wix-data-client-common'
import { APP_DEF_ID, isClassicEditor } from '@wix/wix-data-client-common'
import type { DatasetConfig } from '../../worker/data-binding-api'
import type Experiments from '@wix/wix-experiments'

interface Params {
  displayName: string
  datasetType: DatasetType
  config: DatasetConfig
  experimentsManager: Experiments
  editorType: EDITOR_TYPE
  features: Features
}

export const getDatasetComponentDefinition = ({
  displayName,
  datasetType,
  config,
  editorType,
  features,
}: Params) => {
  return {
    componentType: 'platform.components.AppController',
    data: {
      controllerType: datasetType,
      name: displayName,
      applicationId: APP_DEF_ID,
      settings: JSON.stringify(config),
    },
    ...(features.inspectorXP &&
      isClassicEditor(editorType) && {
        layout: { x: 0, y: 0, fixedPosition: true },
      }),
  }
}
